import React, { useState, useRef, useEffect } from 'react';
import { LogOut, FileText, CreditCard, Crown, Coins } from 'lucide-react';
import { authManager } from '../managers/AuthManager';

import { stripeService } from '../services/stripeService';
import './ProfileMenu.css';

const TIER_COLORS = {
  basic: '#94a3b8',
  pro: '#a78bfa',
  max: '#fbbf24'
};

const ProfileMenu = ({ user, setActiveService, subscription }) => {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef(null);
  const tier = subscription?.tier || 'basic';
  const creditBalance = subscription?.credit_balance || 0;

  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isOpen && menuRef.current && !menuRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isOpen]);

  const handleManageBilling = async () => {
    try {
      await stripeService.openPortal(user.email);
    } catch {
      setActiveService('pricing');
      setIsOpen(false);
    }
  };

  if (!user) return null;

  return (
    <div className="profile-container" ref={menuRef} style={{ display: 'inline-flex', alignItems: 'center', gap: '12px' }}>
      <div 
        className="profile-credit-balance" 
        onClick={() => {
          setActiveService('pricing');
          setIsOpen(false);
        }}
        title="Buy More Credits"
      >
        <Coins size={14} />
        <span>{creditBalance}</span>
      </div>
      <button className="profile-icon-btn" onClick={() => setIsOpen(!isOpen)}>
        <div className="avatar" style={{ borderColor: TIER_COLORS[tier] }}>
          {user.name ? user.name.charAt(0).toUpperCase() : 'U'}
        </div>
        {tier !== 'basic' && (
          <span className="avatar-tier-badge" style={{ background: TIER_COLORS[tier] }}>
            {tier.toUpperCase()}
          </span>
        )}
      </button>

      {isOpen && (
        <div className="profile-dropdown glass-panel">
          <div className="profile-header">
            <div className="profile-name-row">
              <div className="profile-name">{user.name}</div>
              <span className="tier-pill" style={{ background: `${TIER_COLORS[tier]}22`, color: TIER_COLORS[tier], border: `1px solid ${TIER_COLORS[tier]}44` }}>
                {tier.charAt(0).toUpperCase() + tier.slice(1)}
              </span>
            </div>
            <div className="profile-email">{user.email}</div>
          </div>
          
          <div className="profile-divider"></div>
          
          <button 
            className="profile-menu-item"
            onClick={() => {
              setActiveService('drafts');
              setIsOpen(false);
            }}
          >
            <FileText size={18} />
            <span>Drafts and Saved</span>
          </button>

          <button 
            className="profile-menu-item"
            onClick={() => {
              setActiveService('pricing');
              setIsOpen(false);
            }}
          >
            <Crown size={18} />
            <span>{tier === 'basic' ? 'Upgrade Plan' : 'Subscription'}</span>
          </button>

          {tier !== 'basic' && (
            <button 
              className="profile-menu-item"
              onClick={handleManageBilling}
            >
              <CreditCard size={18} />
              <span>Manage Billing</span>
            </button>
          )}
          
          <div className="profile-divider"></div>
          
          <button 
            className="profile-menu-item logout"
            onClick={() => {
              authManager.logout();
              setIsOpen(false);
            }}
          >
            <LogOut size={18} />
            <span>Logout</span>
          </button>
        </div>
      )}
    </div>
  );
};

export default ProfileMenu;
